module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!./Web.js"));
	});
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/bundle-loader?lazy!./modules/docs/Web.js
// module id = 481
// module chunks = 3